import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AppAdmins from "../pages/dashboardPage/adminOptions/appAdmins/AppAdmins";
import ControlAds from "../pages/dashboardPage/adminOptions/controlAds/ControlAds";
import MultiPurposeImages from "../pages/dashboardPage/adminOptions/multiPurposeImages/MultiPurposeImages";
import Statistics from "../pages/dashboardPage/adminOptions/statistics/Statistics";

const AdminOptionsNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <Routes>
      <Route path="/statistics" element={<Statistics />} />
      <Route path="/app-admins" element={<AppAdmins />} />
      <Route path="/control-ads" element={<ControlAds />} />
      {rolePermissions.includes("upload-multi-purpose-images") && (
        <Route
          path="/multi-purpose-images"
          element={<MultiPurposeImages />}
        />
      )}
      <Route path="*" element={<Statistics />} />
    </Routes>
  );
};

export default AdminOptionsNavigator;
